'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = DialogHeader;

var _AlertMedium = require('../../Icon/core/AlertMedium');

var _AlertMedium2 = _interopRequireDefault(_AlertMedium);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _DialogButtons = require('./DialogButtons');

var _DialogButtons2 = _interopRequireDefault(_DialogButtons);

var _filterDOMProps = require('../../utils/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _Heading = require('../../Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var VARIANT_ICONS = {
  error: _AlertMedium2.default
};

function DialogHeader(_ref) {
  var title = _ref.title,
      variant = _ref.variant,
      fullscreen = _ref.fullscreen,
      confirmDisabled = _ref.confirmDisabled,
      confirmLabel = _ref.confirmLabel,
      cancelLabel = _ref.cancelLabel,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      className = _ref.className,
      autoFocusButton = _ref.autoFocusButton,
      otherProps = _objectWithoutProperties(_ref, ['title', 'variant', 'fullscreen', 'confirmDisabled', 'confirmLabel', 'cancelLabel', 'onConfirm', 'onCancel', 'className', 'autoFocusButton']);

  var Icon = VARIANT_ICONS[variant];

  return _react2.default.createElement(
    'div',
    _extends({}, (0, _filterDOMProps2.default)(otherProps), {
      className: (0, _classnames2.default)('spectrum-Dialog-header', 'spectrum-Dialog-header--' + variant, className) }),
    _react2.default.createElement(
      _Heading2.default,
      { size: 3, className: 'spectrum-Dialog-title' },
      title
    ),
    Icon && _react2.default.createElement(Icon, { size: null, className: 'spectrum-Dialog-typeIcon' }),
    fullscreen && confirmLabel && _react2.default.createElement(_DialogButtons2.default, {
      autoFocusButton: autoFocusButton,
      variant: variant,
      cancelLabel: cancelLabel,
      confirmLabel: confirmLabel,
      confirmDisabled: confirmDisabled,
      onConfirm: onConfirm,
      onCancel: onCancel })
  );
}